// Magic Link Login Form Validation
// turbo:load で初期化する。/login からの Turbo Drive 遷移後もバインドする。
function initMagicLinkLogin() {
  const form = document.getElementById('magic-link-form');

  if (!form || form.dataset.magicLinkBound === 'true') return;
  form.dataset.magicLinkBound = 'true';

  const emailInput = form.querySelector('#email');
  const submitButton = form.querySelector('[type="submit"]');
  if (!emailInput || !submitButton) return;

  // クライアントサイドバリデーション
  form.addEventListener('submit', function(e) {
    const email = emailInput.value.trim();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!email) {
      e.preventDefault();
      alert('メールアドレスを入力してください');
      emailInput.focus();
      return;
    }

    if (!emailRegex.test(email)) {
      e.preventDefault();
      alert('有効なメールアドレスを入力してください');
      emailInput.focus();
      return;
    }

    // ローディング表示
    submitButton.disabled = true;
    submitButton.value = '送信中...';
  });

  // フォーカス時にエラー状態をクリア
  emailInput.addEventListener('focus', function() {
    emailInput.classList.remove('error');
  });
}

document.addEventListener('turbo:load', initMagicLinkLogin);
if (document.readyState !== 'loading') initMagicLinkLogin();

document.addEventListener('turbo:before-cache', function() {
  const form = document.getElementById('magic-link-form');
  if (form) delete form.dataset.magicLinkBound;
});
